import React, { useEffect, useState } from 'react';
import './AdminFeeStructure.css';
import axios from 'axios';
import { resources } from '../Resourses/Resources';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import Tooltip from '@mui/material/Tooltip';

const AdminFeeStructure = () => {
    const [data, setData] = useState({ level: "", academicYear: "", amount: "" });
    const [editIndex, setEditIndex] = useState(null);
    const [feeStructureTable, setFeeStructureTable] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const date = new Date();
    const currentMonth = date.getMonth() + 1;
    const currentYear = date.getFullYear();
    const acy = currentMonth >= 6 ? `${currentYear}-${currentYear + 1}` : `${currentYear - 1}-${currentYear}`;
    const acyList = [acy, ...Array.from({ length: 5 }, (_, i) => `${currentYear - i - 1}-${currentYear - i}`)];
    const levels = ["DIPLOMA", "UG", "PG"];

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await axios.get(resources.APPLICATION_URL + "getFeeStructureData");
                setFeeStructureTable(response.data);
                setLoading(false);
            } catch (error) {
                setLoading(false);
                setErrorMessage("Error fetching fee structure data.");
            }
        };
        fetchData();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const postData = {
            feeStructurePrimaryKey: { academicYear: data.academicYear, level: data.level },
            amount: data.amount,
        };

        try {
            setLoading(true);
            const response = await axios.post(resources.APPLICATION_URL + "save/feestructure", postData);
            setLoading(false);

            if (response.status === 200) {
                alert("Successfully Added");
                setData({ level: "", academicYear: "", amount: "" });
                setFeeStructureTable([...feeStructureTable, { feeStructurePrimaryKey: { academicYear: data.academicYear, level: data.level }, amount: data.amount }]);
            }
        } catch (error) {
            setLoading(false);
            setErrorMessage("Error saving fee structure.");
        }
    };

    const handleEdit = (i) => {
        setEditIndex(i); 
    };

    const handleSave = async (i) => {
        const updatedItem = feeStructureTable[i];
        const postData = {
            feeStructurePrimaryKey: {
                academicYear: updatedItem.feeStructurePrimaryKey.academicYear,
                level: updatedItem.feeStructurePrimaryKey.level
            },
            amount: updatedItem.amount,
        };

        try {
            setLoading(true);
            const response = await axios.post(resources.APPLICATION_URL + "save/feestructure", postData);

            if (response.status === 200) {
                alert("Fee structure updated successfully");

                const updatedTable = [...feeStructureTable];
                updatedTable[i] = { ...updatedItem };
                setFeeStructureTable(updatedTable);
                setEditIndex(null); 
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            setErrorMessage("Error updating fee structure.");
        }
    };

    const handleDelete = async (i) => {
        const feeToDelete = feeStructureTable[i];
        const academicYear = feeToDelete.feeStructurePrimaryKey.academicYear;
        const level = feeToDelete.feeStructurePrimaryKey.level;
    
        try {
            setLoading(true);
            const response = await axios.delete(
                `${resources.APPLICATION_URL}deletefeestructuredata?academicyear=${academicYear}&level=${level}`
            );
    
            if (response.status === 200) {
                alert("Fee structure deleted successfully");
                const updatedTable = feeStructureTable.filter((_, index) => index !== i);
                setFeeStructureTable(updatedTable);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            setErrorMessage("Error deleting fee structure.");
        }
    };

    return (
        <div>
            <h2 style={{ textAlign: "center", marginTop: "20px", marginBottom: "20px" }}>Fee Structure</h2>

            <div className="all_dropdown_container">
                <div className="all_dropdowns">
                    <label>Level</label>
                    <select onChange={(e) => setData({ ...data, level: e.target.value })} value={data.level}>
                        <option>Select Level</option>
                        {levels.map((item) => <option key={item}>{item}</option>)}
                    </select>
                </div>

                <div className="all_dropdowns">
                    <label>Academic Year</label>
                    <select onChange={(e) => setData({ ...data, academicYear: e.target.value })} value={data.academicYear}>
                        <option>Select Academic Year</option>
                        {acyList.map((item) => <option key={item}>{item}</option>)}
                    </select>
                </div>

                <div className="all_dropdowns">
                    <label>Fee /Year</label>
                    <input 
                        type="number" 
                        placeholder="Fee /Year" 
                        value={data.amount} 
                        onChange={(e) => setData({ ...data, amount: e.target.value })}
                    />
                </div>

                <div className="all_dropdowns">
                    <button onClick={handleSubmit} disabled={loading || !data.level || !data.academicYear || !data.amount}>Save</button>
                </div>
            </div>

            {errorMessage && <p style={{ color: "red", textAlign: "center" }}>{errorMessage}</p>}

            <div className="fee_structure_table_container">
                <table className="fee_structure_table">
                    <thead>
                        <tr>
                            <th>S.NO</th>
                            <th>Level</th>
                            <th>Academic Year</th>
                            <th>Fee /Year</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {feeStructureTable.map((item, i) => (
                            <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{item.feeStructurePrimaryKey.level}</td>
                                <td>{item.feeStructurePrimaryKey.academicYear}</td>
                                <td>
                                    {editIndex === i ? (
                                        <input 
                                            type="number" 
                                            value={item.amount} 
                                            onChange={(e) => {
                                                const updatedItem = { ...item, amount: e.target.value };
                                                setFeeStructureTable(prevState => {
                                                    const updatedTable = [...prevState];
                                                    updatedTable[i] = updatedItem;
                                                    return updatedTable;
                                                });
                                            }}
                                        />
                                    ) : (
                                        item.amount
                                    )}
                                </td>
                                <td>
                                    {editIndex === i ? (
                                        <Tooltip title="Save">
                                            <IconButton aria-label="save" onClick={() => handleSave(i)}>
                                                <SaveIcon sx={{ color: "green" }} />
                                            </IconButton>
                                        </Tooltip>
                                    ) : (
                                        <>
                                            <Tooltip title="Edit">
                                                <IconButton aria-label="edit" onClick={() => handleEdit(i)}>
                                                    <EditIcon sx={{ color: "green" }} />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Delete">
                                                <IconButton aria-label="delete" onClick={() => handleDelete(i)}>
                                                    <DeleteIcon sx={{ color: "red" }} />
                                                </IconButton>
                                            </Tooltip>
                                        </>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminFeeStructure;
